import React from "react";
import { ReactComponent as Gas } from "../../assets/icons/Gas.svg";
import { ReactComponent as Water } from "../../assets/icons/Water.svg";
import { ReactComponent as Electricity } from "../../assets/icons/Electricity.svg";
import { ReactComponent as MCI } from "../../assets/icons/MCI.svg";
import { ReactComponent as PayWithNumber } from "../../assets/icons/PayWithNumber.svg";
import { ReactComponent as Irancell } from "../../assets/icons/Irancell.svg";
import { ReactComponent as TCI } from "../../assets/icons/TCI.svg";
import { ReactComponent as Wait } from "../../assets/icons/WaitingForPayment.svg";
import { ReactComponent as Usage } from "../../assets/icons/UsageManager.svg";
import { ReactComponent as History } from "../../assets/icons/PaymentHistory.svg";
import { ReactComponent as SMSPay } from "../../assets/icons/SMSPay.svg";
import { useHistory } from "react-router-dom";

const MenuItems = [
  // {
  //   text: "سوابق پرداخت",
  //   img: require("../../assets/images/history@3x.png"),
  //   path: "/history",
  // },
  // {
  //   text: "مدیریت مصرف",
  //   img: require("../../assets/images/use@3x.png"),
  //   path: "/usage",
  // },
  {
    text: "اطلاعات کاربری",
    img: require("../../assets/images/user@3x.png"),
    path: "/profile",
  },
  {
    text: "پیام ها",
    img: require("../../assets/images/MenuMessages.png"),
    path: "/Messages",
  },
  {
    text: "سوالات متداول",
    img: require("../../assets/images/faq@3x.png"),
    path: "/FAQ",
  },
  {
    text: "ربات تلگرام کنتور",
    img: require("../../assets/images/bot@3x.png"),
    path: "https://t.me/mycontorbot",
    link: true,
  },
  {
    text: "ارتباط با پشتیبانی",
    img: require("../../assets/images/telegram@3x.png"),
    path: "https://t.me/contorapp",
    link: true,
  },
  {
    text: "پیام متنی به پشتیبانی",
    img: require("../../assets/images/Ticket.png"),
    path: "/Tickets",
  },
  {
    text: "درباره کنتور",
    img: require("../../assets/images/aboutUs@3x.png"),
    path: "/aboutus",
  },
  {
    text: "تماس با ما",
    img: require("../../assets/images/contactUs@3x.png"),
    path: "/contactus",
  },
  {
    text: "خروج",
    img: require("../../assets/images/logout@3x.png"),
    path: "/login",
  },
];

const MainPageCompanies = [
  {
    text: "قبض آب",
    icon: <Water style={{ width: window.innerWidth * 0.3, height: "auto" }} />,
    path: `/Payment/Water`,
    companyId: 1,
  },
  { text: "قبض گاز", icon: <Gas />, path: `/Payment/Gas`, companyId: 2 },

  {
    text: "قبض برق",
    icon: <Electricity />,
    path: `/Payment/Electricity`,
    companyId: 3,
  },
  { text: "قبض موبایل", icon: <MCI />, path: `/Payment/Mobile`, companyId: 4 },
  {
    text: "قبض تلفن ثابت",
    icon: <TCI />,
    path: `/Payment/Telephone`,
    companyId: 5,
  },
  {
    text: "قبض ایرانسل",
    icon: <Irancell />,
    path: `/Payment/Irancell`,
    companyId: 6,
  },
  {
    text: "پرداخت با شناسه قبض و پرداخت",
    icon: <PayWithNumber />,
    path: `/Payment/Irancell`,
    companyId: 7,
  },
  {
    text: "پرداخت مستقیم پیامک‌های دریافتی از سازمان‌ها",
    icon: <SMSPay />,
    path: `/Payment/Irancell`,
    companyId: 7,
  },
];
const MainPageMenus = [
  {
    text: "در انتظار پرداخت",
    icon: <Wait />,
    path: "/waiting",
  },
  { text: "مدیریت مصرف", icon: <Usage />, path: "/usage" },
  { text: "سوابق پرداخت", icon: <History />, path: "/history" },
];

export const CompanyFirstRow = () => {
  return (
    <div className="CompanyFirstRow">
      {MainPageCompanies.map((i, index) => {
        if (index < 3) {
          return (
            <ComponyComponent item={i} key={`company${index}`} index={index} />
          );
        } else return null;
      })}
    </div>
  );
};
export const MainBottomMenu = () => {
  return (
    <div className="MainBottomMenu">
      {MainPageMenus.map((i, index) => {
        return <MenuComponent item={i} key={`company${index}`} />;
      })}
      <div className="MainBottomInner"></div>
    </div>
  );
};
export const CompanySecondRow = () => {
  return (
    <div className="CompanySecondRow">
      {MainPageCompanies.map((i, index) => {
        if (index > 2 && index < 6) {
          return (
            <ComponyComponent item={i} key={`company${index}`} index={index} />
          );
        } else return null;
      })}
    </div>
  );
};
export const CompanyThirdRow = () => {
  return (
    <div className="CompanyThirdRow">
      {MainPageCompanies.map((i, index) => {
        if (index > 5) {
          return (
            <ComponyComponent item={i} key={`company${index}`} index={index} />
          );
        } else return null;
      })}
    </div>
  );
};

const MenuItemComponent = ({
  deleteUser,
  deleteToken,
  logout,
  history,
  item,
  open,
}) => {
  return (
    <div
      className={open ? "MainPageMenuItemOpen" : "MainPageMenuItem"}
      onClick={() => {
        if (!item.link) {
          if (item.path == "/login") {
            deleteUser();
            deleteToken();
            logout();
          }
          history.push(item.path);
        }
      }}
    >
      <img src={item.img} />
      {item.link ? (
        <li>
          <a href={item.path}>{item.text}</a>
        </li>
      ) : (
        <span>{item.text}</span>
      )}
    </div>
  );
};

export const Menu = ({ open, deleteUser, deleteToken, logout, setOpen }) => {
  const history = useHistory();
  return (
    <div
      className={open ? "MenuContainerOpen" : "MenuContainer"}
      onClick={() => setOpen(false)}
    >
      <div className={open ? "BurgerMenuOpen" : "BurgerMenu"}>
        <img
          src={require("../../assets/images/drawer.png")}
          className="Drawerimage"
        />
        {MenuItems.map((i) => (
          <MenuItemComponent
            deleteUser={deleteUser}
            deleteToken={deleteToken}
            logout={logout}
            history={history}
            item={i}
            open={open}
          />
        ))}
      </div>
    </div>
  );
};

const ComponyComponent = ({ item, index }) => {
  const history = useHistory();
  return (
    <div
      className="MainPageCompanyComponent"
      id="Billhistory"
      key={index}
      style={{ animationDelay: `${index * 0.2}s` }}
      onClick={() =>
        history.push({
          pathname: item.path,
        })
      }
    >
      <div>{item.icon}</div>
      <span>{item.text}</span>
    </div>
  );
};
const MenuComponent = ({ item }) => {
  const history = useHistory();
  return (
    <div
      className="MainPageMenuComponent"
      onClick={() => history.push(item.path)}
    >
      <div>{item.icon}</div>
      <span>{item.text}</span>
    </div>
  );
};

export const BottomDarkBlue = () => {
  return (
    <img
      src={require("../../assets/images/mainBottom@3x.png")}
      className="BottomDarkBlue"
    />
  );
};
